import React, { useState } from "react";
import { Tooltip } from "antd";

const getInputError = (inputValue) => {
  if (!inputValue) {
    return { isValid: true, errorMessage: null };
  }
  const invalidMatch = inputValue.match(/[^0-9,\\.]/);
  if (invalidMatch !== null) {
    const invalidChar = invalidMatch[0] === " " ? "space" : invalidMatch[0];
    return { isValid: false, errorMessage: `Invalid input, remove ${invalidChar}` };
  }
  if (/\.(?=[^\\.]*\.+[^\\.]*)/.test(inputValue)) {
    return { isValid: false, errorMessage: "Invalid input, multiple '.'" };
  }
  return { isValid: true, errorMessage: null };
};

export default function SpecManagerInput({
  placeholder = "",
  value = "",
  additionalClassName = "",
  onChange,
}) {
  const [errorMessage, setErrorMessage] = useState("");
  const [focused, setFocused] = useState(false);

  const handleKeyDown = (event) => {
    if (event.key.length === 1 && !(event.altKey || event.ctrlKey || event.metaKey)) {
      const validChar = event.key.match(/[0-9,\\.]/);
      let invalid = validChar === null;
      if (validChar !== null && validChar[0] === "." && value.includes(".")) {
        invalid = true;
      }
      if (invalid) {
        event.preventDefault();
      }
    }
    if (event.key === "Enter") {
      event.preventDefault();
      event.target.blur();
    }
  };

  const handleChange = (event) => {
    const text = event.target.value;
    const validation = getInputError(text);
    onChange(text);
    setErrorMessage(validation.errorMessage || "");
  };

  const inputNode = (
    <span className="SpecManager_InputWrap">
      <input
        type="text"
        className={`SpecManager_Input${errorMessage ? " SpecManager_Input--invalid" : ""} ${additionalClassName}`}
        placeholder={placeholder}
        value={value || ""}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
    </span>
  );

  if (focused && errorMessage) {
    return (
      <Tooltip title={errorMessage} open>
        {inputNode}
      </Tooltip>
    );
  }

  return inputNode;
}
